module.exports = __webpack_public_path__ + "static/media/1033164.9ddffbae.jpg";